export const HOME_PATHS = ["/", "/inicio"]

export function isPageAllowed(pathname, pages = []) {
  if (HOME_PATHS.includes(pathname)) return true

  return pages.some(
    (page) => pathname === page || pathname.startsWith(`${page}/`)
  )
}



// WEBPACK FOOTER //
// ./src/services/state/permissions/isPageAllowed.js